import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { withAutoMetric } from '@beef/auto-metric';
import { compose } from '@beef/redux';
import { Container } from '@carnica/smart-kit';
import { enhancedConnect } from "../../utils";
import { Footer, Header, Options } from "../TariffCardBlock/index";
import { AdditionalInfo } from "./components/AdditionalInfo";
import { PromoteBlock } from "./components/PromoteBlock";
import { ConnectButton } from "./components/ConnectButton";
import { CardContainer } from "./components/CardContainer";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/** Компонент карточки тарифа
 * Копипаст с серьезными изменениями от главной страницы. Логика работы не была тронута */

export var _TariffCard = function _TariffCard(_ref) {
  var card = _ref.card,
    topIcon = _ref.topIcon,
    topTitle = _ref.topTitle,
    iconWrapper = _ref.iconWrapper,
    buttonText = _ref.buttonText,
    tariffName = _ref.tariffName,
    tariffUrl = _ref.tariffUrl,
    iconType = _ref.iconType,
    iconColor = _ref.iconColor,
    priceText = _ref.priceText,
    topDescription = _ref.topDescription,
    _ref$promoteBackgroun = _ref.promoteBackground,
    promoteBackground = _ref$promoteBackgroun === void 0 ? 'secondary' : _ref$promoteBackgroun,
    children = _ref.children,
    _ref$connectBtnGoalNa = _ref.connectBtnGoalName,
    connectBtnGoalName = _ref$connectBtnGoalNa === void 0 ? '' : _ref$connectBtnGoalNa,
    contentMinHeight = _ref.contentMinHeight,
    priceTextTop = _ref.priceTextTop;
  var bgImage = card.bgImage,
    options = card.options,
    tagLabel = card.tagLabel,
    button = card.button;
  /* Добавляет bg */
  var style = _objectSpread(_objectSpread({}, bgImage ? {
    backgroundImage: "url(".concat(bgImage, ")")
  } : {}), contentMinHeight ? {
    minHeight: "".concat(contentMinHeight, "px")
  } : {});
  var Tag = tariffUrl ? 'a' : 'div';
  return /*#__PURE__*/React.createElement(CardContainer, {
    className: cx('tariff-card', topTitle && 'transform-card'),
    "data-t-id": "components-TariffCard"
  }, /*#__PURE__*/React.createElement(Tag, {
    className: cx('container'),
    href: tariffUrl || undefined,
    "data-t-id": "components-TariffCard"
  }, topTitle && /*#__PURE__*/React.createElement(PromoteBlock, {
    background: promoteBackground
  }, /*#__PURE__*/React.createElement(AdditionalInfo, {
    description: topDescription,
    icon: topIcon,
    iconColor: iconColor,
    iconType: iconType,
    iconWrapper: iconWrapper,
    invert: false,
    title: topTitle,
    "data-t-id": "components-TariffCard"
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('content', 'content--no-offset'),
    style: style
  }, /*#__PURE__*/React.createElement(Header, {
    tagLabel: tagLabel,
    presetText: tariffName
  }), /*#__PURE__*/React.createElement(Options, options), children && /*#__PURE__*/React.createElement(Container.Flex, {
    direction: "column",
    gap: 8
  }, children), /*#__PURE__*/React.createElement(Footer, {
    priceText: priceText,
    priceTextTop: priceTextTop
  })), /*#__PURE__*/React.createElement(ConnectButton, {
    basketPayload: button.basketPayload,
    priceText: tariffName,
    reachGoal: connectBtnGoalName,
    text: buttonText
  })));
};
export var TariffCard = compose(enhancedConnect({
  card: PropTypes.string,
  topDescription: PropTypes.string,
  topIcon: PropTypes.oneOf(['gift', 'settings']),
  buttonText: PropTypes.string,
  tariffName: PropTypes.string,
  priceText: PropTypes.string,
  iconWrapper: PropTypes.bool,
  iconColor: PropTypes.string,
  connectBtnGoalName: PropTypes.string,
  children: PropTypes.node,
  topTitle: PropTypes.string,
  iconType: PropTypes.oneOf(['filled', 'outline', 'hidden']),
  promoteBackground: PropTypes.oneOf(['primary', 'secondary']),
  priceTextTop: PropTypes.string,
  contentMinHeight: PropTypes.number
}), withAutoMetric.Item(function (props) {
  return {
    price: props.priceText,
    tariffName: props.tariffName
  };
}))(_TariffCard);